import { Component, computed, effect, inject } from '@angular/core';
import { CartSidebarService } from './cart-sidebar.service';
import { BackdropService } from '@components/shared/backdrop/backdrop.service';
import { CartCookieService } from '@core/services/storage/cart/cart-cookie.service';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { CurrencyPipe } from '@angular/common';
import { UserStoreService } from '@core/services/storage/user/user-store.service';

import { RouterLink } from '@angular/router';
import { CartEmptyComponent } from '../cart-empty/cart-empty.component';
import { CartConstraintsService } from '@core/services/utils/cart/cart-constraints.service';
import { MinPriceAlertComponent } from '@components/shared/min-price-alert/min-price-alert.component';



@Component({
    selector: 'app-cart-sidebar',
    imports: [RouterLink,TranslatePipe, FontAwesomeModule, CurrencyPipe, CartEmptyComponent, MinPriceAlertComponent],
    templateUrl: './cart-sidebar.component.html',
    styleUrl: './cart-sidebar.component.scss'
})
export class CartSidebarComponent {

    // services
    protected appConfig = inject(AppConfigService);
    cartSidebarService = inject(CartSidebarService);
    backdropService = inject(BackdropService)
    cartCookieService = inject(CartCookieService);
    userStoreService = inject(UserStoreService);
    cartConstraints = inject(CartConstraintsService);

    // signals
    isOpen = computed(() => this.cartSidebarService.isVisible());
    isMinPriceReached = computed(() => this.cartConstraints.isMinPriceReached());

    totaleCarrello = computed(() => {
        const cart = this.cartCookieService.cartValue(); // Ottiene il valore del signal
        const user = this.userStoreService.user();


        return this.cartCookieService.cartValue().articoli.reduce((total, item) => {

                let price: number = item.prezzo_privati_vat;
                 
                if(this.appConfig.isComORcoUk()) {
                    price = item.prezzo_privati_novat;
                }

                if(this.userStoreService.isLoggedSignal()) {
                    if(this.userStoreService.paga() == 'CON') {
                        if(this.userStoreService.isPrivateSignal()) {
                            price = item.prezzo_privati_vat;
                        }
                        if(this.userStoreService.isProSignal()) {
                            price = item.prezzo_pro_vat;
                        }
                    }
                    if(this.userStoreService.paga() == 'SENZA') {
                        if(this.userStoreService.isPrivateSignal()) {
                            price = item.prezzo_privati_novat;
                        }
                        if(this.userStoreService.isProSignal()) {
                            price = item.prezzo_pro_novat;
                        }
                    }

                    if(this.appConfig.isComORcoUk()) {
                        price = item.prezzo_pro_novat;
                    }

                }

                return total + (price * item.item_quantita);
            }
           , 0
        )
    });

    // icons
    info_icon = faInfoCircle;
    delete_icon = faTrashCan;
    increment_icon = faPlus;
    decrement_icon = faMinus

    constructor() {
        effect(() => {
            if (!this.backdropService.isActive()) {
                // nascondo il cart sidebar
                this.closeSidebar();
            }


        });
    }

    closeSidebar(): void {
       
        this.cartSidebarService.close();
         this.backdropService.hide();
    }

    removeItem(itemId: number) {
        this.cartCookieService.removeItem(itemId);
    }

    incrementItemQty(itemId: number) {
        this.cartCookieService.incrementItemQuantity(itemId);
    }
    decrementItemQty(itemId: number) {
        this.cartCookieService.decrementItemQuantity(itemId);
    }
}
